var _rect, _line, _line2, _line3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSamplesicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "flask",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Boundary",
    width: 24,
    height: 24,
    fill: "none"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_8136",
    "data-name": "Line 8136",
    x2: 3,
    transform: "translate(8 9)",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_8137",
    "data-name": "Line 8137",
    x2: 3,
    transform: "translate(8 13)",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_8138",
    "data-name": "Line 8138",
    x2: 3,
    transform: "translate(8 17)",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M5,1V5H8V19a4,4,0,0,0,4,4h0a4,4,0,0,0,4-4V5h3V1Z",
    fill: "none",
    stroke: "#eef8ff",
    strokeLinecap: "square",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamplesicon);
export default __webpack_public_path__ + "static/media/samplesicon.edef721795a4762f9ebe8106d628b027.svg";
export { ForwardRef as ReactComponent };